import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ChangeDetectionStrategy
} from "@angular/core";
import { RichTextComment, Thread, ThreadAuthor } from "../../timeline-item";
import { TmRichTextAreaComponent } from "../../../shared/ui/rich-text-area/rich-text-area.component";
import { TranslateModule } from "@ngx-translate/core";
import { MatTooltip } from "@angular/material/tooltip";
import { NgClass } from "@angular/common";
import Delta from "quill-delta";
import { CdkTrapFocus } from "@angular/cdk/a11y";
import { UsernameIconComponent } from "../../../shared/ui/username-icon/username-icon.component";
import { UserService } from "@teammood/shared/util/user";
import { UserInfos } from "../../../shared/ui/username-icon/user-infos.type";
import { MatButtonToggle, MatButtonToggleGroup } from "@angular/material/button-toggle";

@Component({
    selector: "tm-thread-input-area",
    templateUrl: "./thread-input-area.component.html",
    styleUrls: ["./thread-input-area.component.scss"],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TmRichTextAreaComponent,
        TranslateModule,
        MatTooltip,
        NgClass,
        CdkTrapFocus,
        UsernameIconComponent,
        MatButtonToggle,
        MatButtonToggleGroup,    ]
})
export class ThreadInputAreaComponent implements OnInit, OnChanges {

    @Input({required: true})
    thread: Thread;

    @Input() userInfos: UserInfos;

    @Input()
    threadAuthors: ThreadAuthor[];

    @Input()
    setFocus: boolean;

    @Input()
    updateMode: boolean = false;

    @ViewChild('newThreadInput') newThreadInput: ElementRef;

    @ViewChild('richTextAreaComponent') richTextAreaComponent: TmRichTextAreaComponent;

    @Output()
    onThreadAdded: EventEmitter<Thread> = new EventEmitter();

    @Output()
    onCancelUpdates: EventEmitter<void> = new EventEmitter();

    @Output()
    onFocusInput: EventEmitter<void> = new EventEmitter();

    protected hideTextareaPlaceholder: boolean;
    protected rtaContent: Delta;
    protected isFieldEmplty: boolean;

    constructor(
        private cdr: ChangeDetectorRef,
        private userService: UserService
    ){}

    ngOnInit() {
        // for whatever reason, we need to explicitly cast the message
        this.thread.message = new RichTextComment(this.thread.message.rawTextFormat, this.thread.message.htmlFormat, this.thread.message.objectModelFormat);
        this.rtaContent = this.thread.message.objectModelFormat;
        this.isFieldEmplty = RichTextComment.isEmptyDelta(this.rtaContent);
        
        if (!this.thread.message.isEmpty()) {
            this.hideTextareaPlaceholder = true;
        }
    }


    ngOnChanges(changes: SimpleChanges) {
        if (changes.setFocus?.currentValue) {
            setTimeout(() => {
                const nativeElement = this.newThreadInput?.nativeElement as HTMLInputElement;
                if (nativeElement) {
                    nativeElement.focus();
                }
            }, 0);
        }
    }

    private hide() {
        this.hideTextareaPlaceholder = false;
        this.rtaContent = new Delta();
        this.isFieldEmplty = true;
        this.onFocusInput.emit();
    }

    protected save() {
        this.thread.message.objectModelFormat = this.rtaContent;
        this.onThreadAdded.emit(this.thread);
        this.hide();
    }

    protected cancelUpdates(): void {
        this.onCancelUpdates.emit();
        this.hide();
    }

    protected setAnonymity(isAnonymous: boolean){
        this.thread.isAnonymous = isAnonymous
    }

    onContentChange(update: Delta){
        this.rtaContent = update;
        this.isFieldEmplty = RichTextComment.isEmptyDelta(this.rtaContent);
        this.cdr.detectChanges(); // Force change detection
    }

    showMentions() {
        this.richTextAreaComponent.showMentions();
    }
}